import { zIndex } from '@billy/design-system'
import { css } from '@emotion/core'

/*
  Lumen v1 ships a single-digit z-index scale (navigation 10, overlay 20, messages 30), while our own scale
  in `zIndex.ts` starts at 100. Map Lumen's global layers onto ours, keeping Lumen's relative order, so its
  dialogs, drawers and messages are not rendered underneath our positioned elements.
  The `local-*` tokens are left alone on purpose: they only order elements inside a component.

  The exception is the Lumen Menu: it is a floating element (position fixed) that uses `local-1`, so it ends up
  below our sticky table headers and other positioned elements. Raise it to the level of our dropdowns.
  There is no token or prop for this, so the hashed Lumen class is matched (same approach as `lumenMenuStackingFix`).
*/
export const lumenZIndex = css`
  html:root {
    --lumen-z-index-global-navigation: ${zIndex.Navbar};
    --lumen-z-index-global-overlay: ${zIndex.Modal};
    --lumen-z-index-global-messages: ${zIndex.Notification};
  }

  :root [class^='_menu_'],
  :root [class*=' _menu_'] {
    z-index: ${zIndex.Dropdown};
  }
`
